import createClient from "openapi-fetch";
import type { paths } from "./openapi";

export const typedApi = createClient<paths>({
  baseUrl: typeof window !== "undefined" ? window.location.origin : "",
  // Use a wrapper so that test environments (MSW) can patch globalThis.fetch
  // after module load without the cached reference bypassing the interceptor.
  fetch: (...args) => globalThis.fetch(...args),
});

export interface Page<T> {
  items: T[];
  total: number;
  page: number;
  page_size: number;
}
